
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dnrkU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4844ee22f14c80d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $5rqex = parcelRequire("5rqex");

var $4dRjY = parcelRequire("4dRjY");

var $dZw8H = parcelRequire("dZw8H");


var $kiW0v = parcelRequire("kiW0v");

var $dd89D = parcelRequire("dd89D");
function $e4844ee22f14c80d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "contactAdministrator",
        packageName: "jiraAdminContactAmin",
        teamName: "jira-notifications-platform"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $a9f4cf79fbba9035$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kiW0v.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: (0, $dd89D.METRICS_PAGE_ID),
        metric: (0, $dd89D.contactAdminPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
}

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


// analytics constants
const $a9f4cf79fbba9035$export$a3821bc63538b210 = 'contactAdministrator';

parcelRegister("kiW0v", function(module, exports) {

$parcel$export(module.exports, "default", () => $897032101f9c87a7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bAkIV = parcelRequire("bAkIV");

var $92Z2l = parcelRequire("92Z2l");

var $19eeP = parcelRequire("19eeP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $4byzx = parcelRequire("4byzx");

var $65L2Q = parcelRequire("65L2Q");

var $5Gug0 = parcelRequire("5Gug0");

var $bp5ow = parcelRequire("bp5ow");
const $897032101f9c87a7$var$CONTACT_ADMINT_PACKAGE_NAME = 'jiraAdminPagesContactAdministrator';
const $897032101f9c87a7$var$ContactAdministrator = ()=>{
    const [pageCrash, updatePageCrash] = (0, $5uXOq.useState)(false);
    const { loading: loading, error: error, data: data, fetchContactAdminDetails: fetchContactAdminDetails } = (0, $4byzx.useContactAdministratorDetails)();
    (0, $5uXOq.useEffect)(()=>{
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        fetchContactAdminDetails();
    }, [
        fetchContactAdminDetails
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.trackFetchErrors)({
            error: error,
            id: 'fetchContactAdminDetails',
            packageName: $897032101f9c87a7$var$CONTACT_ADMINT_PACKAGE_NAME
        });
    }, [
        error
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isEnabled: isEnabled, message: message, to: to, replyTo: replyTo, reCaptchaSharedKey: reCaptchaSharedKey } = data;
    if (error || pageCrash) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $19eeP.default), null);
    if (loading) return null;
    const appearance = isEnabled ? 'information' : 'warning';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAkIV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($897032101f9c87a7$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($897032101f9c87a7$var$PageHeader, null, formatMessage((0, $5Gug0.default).pageHeader)), message !== null && message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($897032101f9c87a7$var$FormContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: appearance,
        testId: "admin-pages-contact-administrator.ui.section-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bp5ow.default), {
        text: message || ''
    }))), isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($897032101f9c87a7$var$FormContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $65L2Q.default), {
        to: to || '',
        replyTo: replyTo || '',
        updatePageCrash: updatePageCrash,
        reCaptchaSharedKey: reCaptchaSharedKey,
        infoBannerMessage: message || ''
    }))));
};
var $897032101f9c87a7$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $897032101f9c87a7$var$ContactAdministrator;
const $897032101f9c87a7$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1c3h _19pkxy5q _2hwx1wug _otyrxy5q _18u01wug",
            __cmplp.className
        ])
    });
});
const $897032101f9c87a7$var$PageHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $897032101f9c87a7$var$FormContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkv47k _p12f1ogm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");
function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f4d1a89146de6ed$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $2f4d1a89146de6ed$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $2f4d1a89146de6ed$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $2f4d1a89146de6ed$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$pageContentStyles
    }, children)));
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephoW.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itnZ9.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});



parcelRegister("19eeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $97291c2c792e4264$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $koVbs = parcelRequire("koVbs");

var $hXguP = parcelRequire("hXguP");

var $7lFIh = parcelRequire("7lFIh");
const $97291c2c792e4264$var$ErrorState = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const errorStateProps = {
        header: formatMessage((0, $7lFIh.default).header),
        description: formatMessage((0, $7lFIh.default).description),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hXguP))),
        maxImageWidth: 250,
        maxImageHeight: 250,
        imageWidth: 225,
        width: 'narrow'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-test-id": "admin-pages-common.ui.error-state.fetch-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), errorStateProps));
};
var $97291c2c792e4264$export$2e2bcd8739ae039 = $97291c2c792e4264$var$ErrorState;

});
parcelRegister("hXguP", function(module, exports) {
module.exports = new URL("error.8fed59f7.svg", import.meta.url).toString();

});

parcelRegister("7lFIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1285663a477e3c46$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1285663a477e3c46$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "admin-pages-common.error-state.header",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "admin-pages-common.error-state.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("4byzx", function(module, exports) {

$parcel$export(module.exports, "useContactAdministratorDetails", () => $e747f13bd948591b$export$b05c9bf05f54cc9c);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $1kGd0 = parcelRequire("1kGd0");
const $e747f13bd948591b$export$b05c9bf05f54cc9c = ()=>{
    const request = (0, $5uXOq.useCallback)(()=>(0, $eusud.performGetRequest)((0, $1kGd0.getFetchContactAdminDetailsURL)()), []);
    const { loading: loading, error: error, data: data = (0, $1kGd0.defaultStateForContactAdminDetails), fetch: fetch } = (0, $ld2hZ.useService)(request);
    const memoisedData = (0, $5uXOq.useMemo)(()=>data, [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoisedData,
        fetchContactAdminDetails: fetch
    };
};

});
parcelRegister("1kGd0", function(module, exports) {

$parcel$export(module.exports, "getFetchContactAdminDetailsURL", () => $82e10cf213fbfd4b$export$764368d8061848e1);
$parcel$export(module.exports, "buildPostSendMailToAdmin", () => $82e10cf213fbfd4b$export$a56c5c9de3b115c3);
$parcel$export(module.exports, "defaultStateForContactAdminDetails", () => $82e10cf213fbfd4b$export$3ebd25f494f95ad3);
const $82e10cf213fbfd4b$export$764368d8061848e1 = ()=>'/rest/internal/3/contactadministrator/configuration';
const $82e10cf213fbfd4b$export$a56c5c9de3b115c3 = ()=>'/rest/internal/3/contactadministrator';
const $82e10cf213fbfd4b$export$3ebd25f494f95ad3 = {
    isEnabled: false,
    message: null,
    to: null,
    replyTo: null,
    reCaptchaSharedKey: null
};

});


parcelRegister("65L2Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8187139fbf1a551e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $2rqOp = parcelRequire("2rqOp");

var $efXp3 = parcelRequire("efXp3");
var $7O4UO = parcelRequire("7O4UO");

var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $6LCpJ = parcelRequire("6LCpJ");

var $kY99m = parcelRequire("kY99m");

var $184t6 = parcelRequire("184t6");

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $cXoTB = parcelRequire("cXoTB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVJAU = parcelRequire("lVJAU");

var $biQTN = parcelRequire("biQTN");


var $3tiGp = parcelRequire("3tiGp");

var $fmq8C = parcelRequire("fmq8C");
const $8187139fbf1a551e$var$ERROR_FLAG_ID = (0, $7HGHK.toFlagId)('CONTACT_ADMIN_SUBMIT_ERROR');
const $8187139fbf1a551e$var$SUCCESS_FLAG_ID = (0, $7HGHK.toFlagId)('CONTACT_ADMIN_SUBMIT_SUCESS');
const $8187139fbf1a551e$var$ContactAdminForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { to: to, replyTo: replyTo, updatePageCrash: updatePageCrash, reCaptchaSharedKey: reCaptchaSharedKey, infoBannerMessage: infoBannerMessage } = props;
    const { loading: loading, error: postApiError, data: data, sendMailToAdmin: sendMailToAdmin } = (0, $biQTN.useSendMailToAdmin)();
    const config = (0, $5uXOq.useMemo)(()=>({
            sitekey: reCaptchaSharedKey || ''
        }), [
        reCaptchaSharedKey
    ]);
    const shouldRecaptchaWork = (0, $5uXOq.useMemo)(()=>reCaptchaSharedKey !== null, [
        reCaptchaSharedKey
    ]);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isSubmitEnabled, updateSubmitState] = (0, $5uXOq.useState)(!shouldRecaptchaWork);
    const onVerify = (0, $5uXOq.useCallback)(()=>{
        updateSubmitState(true);
    }, []);
    const onLoad = (0, $5uXOq.useCallback)(()=>{
    // can be relied upon to see if script was loaded in UI or not
    // no analytics needed
    }, []);
    const onRender = (0, $5uXOq.useCallback)(()=>{
    // TODO: analytics to inform google RECAPTCHA was successfully rendered in UI
    // no analytics needed
    }, []);
    const onError = (0, $5uXOq.useCallback)(()=>{
        updatePageCrash(true);
        (0, $jcw0u.default)({
            error: new Error('failed to verify recaptcha validation'),
            meta: {
                id: 'contactAdminRecaptchaErrorCallback',
                packageName: (0, $1dd39e31d3aef7bb$export$94304011f018d0e7),
                teamName: 'jira-notifications-platform'
            },
            // Skipping sentry since there is no action for us to do.
            skipSentry: true
        });
    }, [
        updatePageCrash
    ]);
    // force user to revalidate the recaptcha if the user Fails
    const onExpire = (0, $5uXOq.useCallback)(()=>{
        if (shouldRecaptchaWork) updateSubmitState(false);
    }, [
        shouldRecaptchaWork
    ]);
    const onScriptError = (0, $5uXOq.useCallback)((error)=>{
        updatePageCrash(true);
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'contactAdminRecaptchaScriptLoadFailed',
                packageName: (0, $1dd39e31d3aef7bb$export$94304011f018d0e7),
                teamName: 'jira-notifications-platform'
            }
        });
    }, [
        updatePageCrash
    ]);
    const callbacks = (0, $5uXOq.useMemo)(()=>({
            onVerify: onVerify,
            onLoad: onLoad,
            onError: onError,
            onExpire: onExpire,
            onRender: onRender,
            onScriptError: onScriptError
        }), [
        onVerify,
        onLoad,
        onError,
        onExpire,
        onRender,
        onScriptError
    ]);
    const { recaptchaComponent: recaptchaComponent, token: captchaToken, reset: reset } = (0, $cXoTB.default)(config, callbacks);
    const onSuccess = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
            action: 'submit'
        }), 'contactAdmin submitted', {
            isRecaptchaEnabled: true,
            isUserLoggedIn: to !== '',
            containsContactAdminMessage: infoBannerMessage !== ''
        });
        showFlag({
            id: $8187139fbf1a551e$var$SUCCESS_FLAG_ID,
            type: 'success',
            testId: 'admin-pages-screens-page.ui.contact-admin-form.success',
            title: (0, $fmq8C.default).successMessageMailSent,
            messageId: 'admin-pages-contact-administrator.ui.contact-admin-form.show-flag.success',
            messageType: 'transactional'
        });
        setTimeout(()=>{
            push('/');
        }, 1000);
    }, [
        createAnalyticsEvent,
        to,
        infoBannerMessage,
        showFlag,
        push
    ]);
    const onFailure = (0, $5uXOq.useCallback)(()=>{
        if (shouldRecaptchaWork) {
            updateSubmitState(false);
            reset();
        }
        if (postApiError) (0, $jcw0u.trackFetchErrors)({
            error: postApiError,
            id: 'sendContactAdminMail',
            packageName: (0, $1dd39e31d3aef7bb$export$94304011f018d0e7)
        });
        if (postApiError && (0, $jJZqs.isValidationError)(postApiError)) {
            const { errors: errors, message: message } = postApiError;
            const errorMessages = errors.map((item)=>item.error.toString());
            if (errorMessages.length >= 1) errorMessages.forEach((item, index)=>showFlag({
                    id: $8187139fbf1a551e$var$ERROR_FLAG_ID,
                    type: 'error',
                    testId: 'admin-pages-screens-page.ui.contact-admin-form.error',
                    title: {
                        id: 'admin-pages-contact-administrator.contact-admin-form.server-error-message-could-not-send-mail',
                        defaultMessage: item,
                        description: 'Mail could not be sent'
                    },
                    messageId: `admin-pages-contact-administrator.ui.contact-admin-form.showFlag.error.server-error-message-could-not-send-mail.${index}`,
                    messageType: 'transactional'
                }));
            if (message) showFlag({
                id: $8187139fbf1a551e$var$ERROR_FLAG_ID,
                type: 'error',
                testId: 'admin-pages-screens-page.ui.contact-admin-form.error',
                title: {
                    id: 'admin-pages-contact-administrator.contact-admin-form.server-error-message-could-not-send-mail',
                    defaultMessage: message,
                    description: 'Mail could not be sent'
                },
                messageId: 'admin-pages-contact-administrator.ui.contact-admin-form.show-flag.error.server-error-message-could-not-send-mail',
                messageType: 'transactional'
            });
            if (errorMessages.length >= 1 || message) return;
        }
        showFlag({
            id: $8187139fbf1a551e$var$ERROR_FLAG_ID,
            type: 'error',
            testId: 'admin-pages-screens-page.ui.contact-admin-form.error',
            title: (0, $fmq8C.default).errorMessageCouldNotSendMail,
            messageId: 'admin-pages-contact-administrator.ui.contact-admin-form.show-flag.error.error-message-could-not-send-mail',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        postApiError,
        reset,
        shouldRecaptchaWork
    ]);
    const onBack = (0, $5uXOq.useCallback)(()=>{
        // TODO: add analytics
        push('/');
    }, [
        push
    ]);
    // @ts-expect-error - TS1064 - The return type of an async function or method must be the global Promise<T> type. Did you mean to write 'Promise<undefined>'? | TS2355 - A function whose declared type is neither 'void' nor 'any' must return a value.
    const handleSubmit = async (formData)=>{
        const { requestDetails: requestDetails, fromEmail: fromEmail, subject: subject } = formData;
        const captchaId = captchaToken || '';
        sendMailToAdmin({
            requestDetails: requestDetails,
            fromEmail: fromEmail,
            subject: subject,
            captchaId: captchaId
        });
    };
    (0, $5uXOq.useEffect)(()=>{
        if (postApiError) onFailure();
    }, [
        onFailure,
        postApiError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (data === null) onSuccess();
    }, [
        data,
        onSuccess
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const lengthLimit = (length)=>(value)=>value.length > length ? formatMessage((0, $fmq8C.default).errorMessageToLarge) : undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isValidEmail = (value)=>!(0, $184t6.default)(value) ? formatMessage((0, $fmq8C.default).errorMessageEmailNotValid) : undefined;
    return(// @ts-expect-error - TS2322 - Type '{ children: ({ formProps }: { formProps: FormChildrenProps; disabled: boolean; dirty: boolean; submitting: boolean; getState: () => FormState<FormData, Partial<FormData>>; getValues: () => FormData; setFieldValue: (name: string, value: any) => void; reset: (initialValues?: FormData | undefined) => void; }) => Elemen...' is not assignable to type 'IntrinsicAttributes & FormProps<FormData>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmit,
        id: (0, $1dd39e31d3aef7bb$export$915ffb06a8a6e6c6)
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
            spacing: "compact"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), {
            medium: 8
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $fmq8C.default).toLabel),
            name: "to",
            id: "reciepient-email",
            defaultValue: to
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                isDisabled: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tiGp.default), {
                error: error
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $fmq8C.default).fromLabel),
            name: "fromEmail",
            isRequired: true,
            id: "sender-email",
            validate: isValidEmail,
            defaultValue: replyTo
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tiGp.default), {
                error: error
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $fmq8C.default).subjectLabel),
            name: "subject",
            isRequired: true,
            id: "mail-subject",
            validate: lengthLimit((0, $1dd39e31d3aef7bb$export$a4eecc9fa5c5c7ca)),
            defaultValue: ""
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), fieldProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tiGp.default), {
                error: error
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $fmq8C.default).detailsLabel),
            name: "requestDetails",
            isRequired: true,
            id: "mail-details",
            validate: lengthLimit((0, $1dd39e31d3aef7bb$export$294ab138e99bd035)),
            defaultValue: ""
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6LCpJ.default), {
                ...fieldProps,
                minimumRows: 10
            }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3tiGp.default), {
                error: error
            })))))), shouldRecaptchaWork && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$ButtonContiner, null, recaptchaComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$ButtonContiner, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$ButtonWrapper, {
            "data-test-id": "admin-pages-contact-administrator.ui.contact-admin-form.submit-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rqOp.default), {
            appearance: "primary",
            type: "submit",
            isLoading: loading,
            isDisabled: !isSubmitEnabled
        }, "Submit")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8187139fbf1a551e$var$ButtonWrapper, {
            "data-test-id": "admin-pages-contact-administrator.ui.contact-admin-form.cancel-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle-link",
            type: "button",
            onClick: onBack,
            isDisabled: loading
        }, "Cancel"))))));
};
var $8187139fbf1a551e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8187139fbf1a551e$var$ContactAdminForm;
const $8187139fbf1a551e$var$ButtonContiner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyrpxbi _18u0v77o _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8187139fbf1a551e$var$ButtonWrapper = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "br68o4-0"
})({
    marginRight: "var(--ds-space-100, 8px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8187139fbf1a551e$var$FieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi _2hwxidpf _otyrpxbi _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});

parcelRegister("184t6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00797b17725d914$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
var $a00797b17725d914$export$2e2bcd8739ae039 = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};

});

parcelRegister("cXoTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbb58b4054544c2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $chkrn = parcelRequire("chkrn");
const $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_PATH = 'https://www.google.com/recaptcha/enterprise.js?render=explicit';
const $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_REGEX = /(http|https):\/\/(www)?.+\/recaptcha/;
const $3bbb58b4054544c2$var$useCheckboxRecaptcha = (config, callbacks)=>{
    const [instanceId, updateInstanceId] = (0, $5uXOq.useState)(null);
    const [token, updateToken] = (0, $5uXOq.useState)(null);
    const callbacksRef = (0, $5uXOq.useRef)(callbacks);
    const configRef = (0, $5uXOq.useRef)(config);
    const onVerifyWrapper = (0, $5uXOq.useCallback)((newToken)=>{
        updateToken(newToken);
        if (callbacksRef.current.onVerify) callbacksRef.current.onVerify(newToken);
    }, []);
    const callBackRef = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'node' implicitly has an 'any' type.
    async (node)=>{
        if (!node || false) return;
        try {
            const sriptLoaded = await (0, $chkrn.injectScript)(`${$3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_PATH}`, $3bbb58b4054544c2$var$RECAPTCHA_SCRIPT_REGEX);
            if (sriptLoaded && callbacksRef.current.onLoad) callbacksRef.current.onLoad();
            const newInstanceId = (0, $chkrn.getRecaptchaMethods)().render(node, {
                callback: onVerifyWrapper,
                'expired-callback': callbacksRef.current.onExpire,
                'error-callback': callbacksRef.current.onError,
                ...configRef.current
            });
            updateInstanceId(newInstanceId);
            if (callbacksRef.current.onRender) callbacksRef.current.onRender();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (callbacksRef.current.onScriptError) callbacksRef.current.onScriptError(error instanceof Error ? error : undefined);
        }
    }, [
        onVerifyWrapper
    ]);
    const recaptchaComponent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: callBackRef
        }), [
        callBackRef
    ]);
    const reset = (0, $5uXOq.useCallback)(()=>{
        if (instanceId !== null) {
            // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number | undefined'.
            (0, $chkrn.getRecaptchaMethods)().reset(instanceId);
            updateToken(null);
        }
    }, [
        instanceId
    ]);
    const getResponse = (0, $5uXOq.useCallback)(()=>{
        if (instanceId !== null) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'number | undefined'.
        return (0, $chkrn.getRecaptchaMethods)().getResponse(instanceId);
        return '';
    }, [
        instanceId
    ]);
    return {
        recaptchaComponent: recaptchaComponent,
        reset: reset,
        token: // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string | null'.
        token,
        getResponse: getResponse
    };
};
var $3bbb58b4054544c2$export$2e2bcd8739ae039 = $3bbb58b4054544c2$var$useCheckboxRecaptcha;

});
parcelRegister("chkrn", function(module, exports) {

$parcel$export(module.exports, "getRecaptchaMethods", () => $112d644f96003f09$export$3bfe7d4134a81119);
$parcel$export(module.exports, "injectScript", () => $112d644f96003f09$export$99edb48b31c60fa0);
const $112d644f96003f09$export$3bfe7d4134a81119 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    window.grecaptcha.enterprise;
const $112d644f96003f09$export$52a8d9f3967f8d4b = (regex)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.scripts).some((script)=>regex.test(script.src));
const $112d644f96003f09$export$99edb48b31c60fa0 = (scriptSrc, regexPattern)=>new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (resolve, reject)=>{
        // if script is already added in html donot add again
        if ($112d644f96003f09$export$52a8d9f3967f8d4b(regexPattern)) {
            resolve(false);
            return;
        }
        // eslint-disable-next-line jira/js/no-document-script, jira/jira-ssr/no-unchecked-globals-usage
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = scriptSrc;
        script.addEventListener('load', ()=>{
            $112d644f96003f09$export$3bfe7d4134a81119().ready(()=>{
                resolve(true);
            });
        });
        // @ts-expect-error - TS2769 - No overload matches this call.
        script.addEventListener('error', (error)=>{
            reject(error);
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.head) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head.appendChild(script);
    });

});


parcelRegister("biQTN", function(module, exports) {

$parcel$export(module.exports, "useSendMailToAdmin", () => $e9aa59092c48b955$export$de59c3aa317e629d);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $1kGd0 = parcelRequire("1kGd0");
const $e9aa59092c48b955$export$de59c3aa317e629d = ()=>{
    const request = (0, $5uXOq.useCallback)((options)=>(0, $eusud.performPostRequest)((0, $1kGd0.buildPostSendMailToAdmin)(), {
            body: JSON.stringify(options)
        }), []);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    const memoisedData = (0, $5uXOq.useMemo)(()=>data, [
        data
    ]);
    return {
        loading: loading,
        error: error,
        data: memoisedData,
        sendMailToAdmin: fetch
    };
};

});

const $1dd39e31d3aef7bb$export$915ffb06a8a6e6c6 = 'contact-administrators';
const $1dd39e31d3aef7bb$export$a4eecc9fa5c5c7ca = 1000;
const $1dd39e31d3aef7bb$export$294ab138e99bd035 = 10000;
const $1dd39e31d3aef7bb$export$94304011f018d0e7 = 'jiraAdminPagesContactAdministrator';

parcelRegister("3tiGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $574caa8fa9c12187$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $qfj8c = parcelRequire("qfj8c");
function $574caa8fa9c12187$export$2e2bcd8739ae039({ error: error }) {
    return error !== undefined && !!error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error) : null;
}

});

parcelRegister("fmq8C", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b96855d1f787d72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4b96855d1f787d72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toLabel: {
        "id": "admin-pages-contact-administrator.contact-admin-form.to-label",
        "defaultMessage": "To"
    },
    toValue: {
        "id": "admin-pages-contact-administrator.contact-admin-form.to-value",
        "defaultMessage": "Jira administrator"
    },
    fromLabel: {
        "id": "admin-pages-contact-administrator.contact-admin-form.from-label",
        "defaultMessage": "From"
    },
    subjectLabel: {
        "id": "admin-pages-contact-administrator.contact-admin-form.subject-label",
        "defaultMessage": "Subject"
    },
    detailsLabel: {
        "id": "admin-pages-contact-administrator.contact-admin-form.details-label",
        "defaultMessage": "Request details"
    },
    errorMessageToLarge: {
        "id": "admin-pages-contact-administrator.contact-admin-form.error-message-to-large",
        "defaultMessage": "You\u2019ve exceeded the character limit for the subject."
    },
    errorMessageEmailNotValid: {
        "id": "admin-pages-contact-administrator.contact-admin-form.error-message-email-not-valid",
        "defaultMessage": "Enter a valid email address"
    },
    errorMessageCouldNotSendMail: {
        "id": "admin-pages-contact-administrator.contact-admin-form.error-message-could-not-send-mail",
        "defaultMessage": "We couldn't send the email. Try again in some time "
    },
    successMessageMailSent: {
        "id": "admin-pages-contact-administrator.contact-admin-form.success-message-mail-sent",
        "defaultMessage": "We\u2019ve reached out to your Jira administrator."
    }
});

});


parcelRegister("5Gug0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6ef53ce64c67cf9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c6ef53ce64c67cf9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageHeader: {
        "id": "admin-pages-contact-administrator.page-header",
        "defaultMessage": "Contact Jira Administrators"
    },
    noContactFormConfirgured: {
        "id": "admin-pages-contact-administrator.no-contact-form-confirgured",
        "defaultMessage": "Your Jira administrator hasn\u2019t configured this form yet. Reach out to your admin."
    }
});

});

parcelRegister("bp5ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f8df247474f07d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $17f8df247474f07d$export$2e2bcd8739ae039(props) {
    const { text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: text
        }
    });
}

});


parcelRegister("dd89D", function(module, exports) {

$parcel$export(module.exports, "METRICS_PAGE_ID", () => $148a8f7fc1f6b1da$export$5721fd5d6ba543ca);
$parcel$export(module.exports, "contactAdminPageLoad", () => $148a8f7fc1f6b1da$export$9be21190b3297ece);

var $dGrdR = parcelRequire("dGrdR");
const $148a8f7fc1f6b1da$export$5721fd5d6ba543ca = 'admin.contact-administrator';
const $148a8f7fc1f6b1da$export$9be21190b3297ece = (0, $dGrdR.metrics).pageLoad({
    key: $148a8f7fc1f6b1da$export$5721fd5d6ba543ca
});

});



//# sourceMappingURL=async-jira-admin-pages-contact-administrator.e96e3c84.js.map
